/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseCarouselItemFragment} from '@amblique/contentful/app/contentful/fragments/carousel-item/base-carousel-item.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {ShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/shop-the-look.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullCarouselItemFragment = gql`
  ${BaseCarouselItemFragment}
  ${ImageFragment}
  ${ShopTheLookFragment}
  ${VideoFragment}

  fragment FullCarouselItemFragment on CarouselItem {
    ...BaseCarouselItemFragment

    media {
      ... on Image {
        ...ImageFragment
      }
      ... on ShopTheLook {
        ...ShopTheLookFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
  }
`;
